'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.filter('orDash', function () {
  return function (value) {
    if (value == null) {
      return "-";
    }
    return value;
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/filters/orDash.js
// module id = 2705
// module chunks = 13